import * as React from "react";
import {history} from "load/store";
import {insideHeader} from "egold/utils";
import {useSelector} from "react-redux";
import {IReduxState} from "reducers";
import {useEffect} from "react";
import {notifyAndroid} from "utils/android";

export default function TermsAndConditions() {
    const isAndroid: boolean = useSelector((state: IReduxState) => state.login.isAndroid);
    useEffect(() => {
        window.scrollTo(0, 0);
        if (isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: false});
        }
    }, []);
    return(
        <div style={{overflow: "hidden"}}>
            {insideHeader("Terms of Use", history.goBack)}
            <iframe style={{width: "100%", height: "100vh", overflow: "hidden", border: "none"}}
                    src="https://www.myshubhlife.com/safegold.html"
                    title="Terms of use">
            </iframe>
        </div>
    );
}
